import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormControl, FormDescription, FormField, FormItem, FormLabel } from '@/components/ui/form';
import { MultiSelect } from '@/components/ui/multi-select';

const MultiSelectForm = ({
  options,
  label,
  name,
  className,
  isRequired = false,
  description,
  placeholder,
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const { t } = useTranslation('translation', { keyPrefix: 'inputs' });
  const validationRules = {};

  if (isRequired) {
    validationRules.required = t('required');
  }

  return (
    <div className={`${className}`}>
      <FormField
        name={name}
        control={control}
        rules={validationRules}
        render={({ field }) => (
          <FormItem>
            {label ? <FormLabel>{label}</FormLabel> : null}
            <FormControl>
              <MultiSelect
                options={options}
                onValueChange={field.onChange}
                defaultValue={field.value}
                placeholder={placeholder}
              />
            </FormControl>
            {description ? <FormDescription>{description}</FormDescription> : null}
            {errors[name] && (
              <div className='d-flex align-items-center error-content'>
                <i className='fas fa-exclamation-triangle text-danger mr-2'></i>
                <p className='text-danger p-0 m-0'>{errors[name].message}</p>
              </div>
            )}
          </FormItem>
        )}
      />
      {/* <FormField
        name={name}
        control={control}
        rules={validationRules}
        // disabled={isDisabled}
        render={({ field }) => (
          <FormItem>
            {label ? <FormLabel>{label}</FormLabel> : null}
            <Select
              disabled={isDisabled}
              onValueChange={(value) => {
                field.onChange(value);
                if (onChange) onChange(value);
              }}
              value={field.value}
              defaultValue={field.value}
            >
              <FormControl>
                <SelectTrigger error={!!errors[name]}>
                  <div className={highlightValue ? 'tw-font-bold' : ''}>
                    <SelectValue placeholder={placeholder} />
                  </div>
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                {options &&
                  options.map((o) => (
                    <SelectItem key={o.value} value={o.value}>
                      {o.label}{' '}
                      {o.description ? (
                        <span className='tw-text-muted-foreground'>{o.description}</span>
                      ) : null}
                    </SelectItem>
                  ))}
              </SelectContent>
            </Select>
            {description ? <FormDescription>{description}</FormDescription> : null}
            {errors[name] && (
              <div className='d-flex align-items-center error-content'>
                <i className='fas fa-exclamation-triangle text-danger mr-2'></i>
                <p className='text-danger p-0 m-0'>{errors[name].message}</p>
              </div>
            )}
          </FormItem>
        )}
      /> */}
    </div>
  );
};

export default MultiSelectForm;
